import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Form, Modal } from "antd";
import Icon from "./MaterialIcon";
import moment from "moment-jalaali";
@connect(
  (state) => ({
    forms: state.Forms,
  }),
  {},
  null,
  { withRef: true }
)
@autobind
/**
 *
 * @extends React.PureComponent
 */
export default class Field extends React.PureComponent {
  static propTypes = {
    hint: PropTypes.node,
    label: PropTypes.node,
    forms: PropTypes.object,
    onSubmit: PropTypes.func,
    validate: PropTypes.func,
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.string,
    component: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    masked: PropTypes.bool,
    children: PropTypes.node,
    parser: PropTypes.func,
    closeAble: PropTypes.func,
    onChange: PropTypes.func,
    confirmText: PropTypes.node,
    className: PropTypes.string,
    componentName: PropTypes.string,
  };

  static contextTypes = {
    _form: PropTypes.object.isRequired,
  };

  static defaultProps = {
    confirmText: "",
    className: "",
    validate: () => true,
    parser: (value) => value,
    editing: false,
    disabled: false,
    required: false,
    masked: false,
    closeAble: (value = true) => true,
    onChange: (value = true) => value,
    componentName: "text",
  };

  /**
   *
   * @param {Object} props
   * @param {Object} context
   */
  constructor(props, context) {
    super(props, context);

    if (!context._form) {
      throw new Error("Field must be inside a component decorated with form()");
    }

    this.state = {
      editing: false,
      hovered: false,
      values: {},
      // value: props.forms[context._form.name][props.name] ? `${props.forms[context._form.name][props.name]}` : undefined,
      value: props.forms[context._form.name][props.name]
        ? props.componentName !== "Cascader"
          ? `${props.forms[context._form.name][props.name]}`
          : props.forms[context._form.name][props.name]
        : undefined,
    };
  }

  /**
   *
   */
  componentDidMount() {
    document.addEventListener("click", this._onOutsideClick, false);
  }

  /**
   *
   * @param {Object} nextProps
   * @param {Object} nextContext
   */
  componentWillReceiveProps(nextProps, nextContext) {
    if (
      !app._.isEqual(
        nextProps.forms[nextContext._form.name],
        this.props.forms[nextContext._form.name]
      )
    ) {
      this.setState({
        values: nextProps.forms[nextContext._form.name],
        //value: nextProps.forms[nextContext._form.name][nextProps.name] ? `${nextProps.forms[nextContext._form.name][nextProps.name]}` : undefined,
        value: nextProps.forms[nextContext._form.name][nextProps.name]
          ? nextProps.componentName !== "Cascader"
            ? `${nextProps.forms[nextContext._form.name][nextProps.name]}`
            : nextProps.forms[nextContext._form.name][nextProps.name]
          : undefined,
      });
    }
  }

  /**
   *
   */
  componentWillUpdate() {
    document.removeEventListener("click", this._onOutsideClick, false);
  }

  /**
   *
   */
  componentDidUpdate() {
    document.addEventListener("click", this._onOutsideClick, false);
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();

    document.removeEventListener("click", this._onOutsideClick, false);
  }

  /**
   *
   * @param {*} e
   * @private
   */
  _onOutsideClick(e) {
    if (this.state.editing && this._node && !this._node.contains(e.target)) {
      if (this.props.closeAble()) {
        this._onSubmit();
      }
    }
  }

  /**
   *
   * @private
   */
  _onEdit() {
    const { disabled, defaultValue, componentName } = this.props;
    if (!this.context._form.disabled && !disabled) {
      this.setState((prevState) => {
        let v = app._.isEmpty(prevState.value)
          ? componentName !== "Cascader" && defaultValue
            ? `${defaultValue}`
            : defaultValue
          : componentName !== "Cascader" && prevState.value
          ? `${prevState.value}`
          : prevState.value;
        if (componentName === "Cascader" && typeof v === "string") {
          v = v.split(",").map((_i) => parseInt(_i));
        }

        return {
          editing: true,
          hovered: false,
          confirm: true,
          // value: app._.isEmpty(prevState.value) ? `${defaultValue}` : prevState.value ? `${prevState.value}` : undefined,
          value: v,
        };
      });
    }
  }

  /**
   *
   * @param {*} event
   * @private
   */
  _onChange(event) {
    let value;

    try {
      value = app.transform.fa2en(event.target.value);
    } catch (err) {
      value = event;
    }

    this.setState({ value }, () => {
      this.props.onChange(value);
    });
  }

  /**
   *
   * @private
   */
  _onCancel() {
    this.setState({
      value: this.state.values[this.props.name],
      editing: false,
    });
  }

  /**
   *
   * @private
   */
  _onSubmit() {
    const { value, values } = this.state;
    const { onSubmit, name, confirmText } = this.props;
    const { _form } = this.context;

    if (this._valid) {
      if (
        (!value && !values[name]) ||
        app._.isEqual(value, `${values[name]}`)
      ) {
        this.setState({
          editing: false,
        });
      } else {
        if (onSubmit) {
          onSubmit(
            value,
            (err) =>
              !err &&
              this.setState({ editing: false }, () =>
                _form.afterSubmit(name, value)
              )
          );
        } else {
          if (this.state.confirm) {
            if (confirmText && confirmText !== "") {
              Modal.confirm({
                title: "هشدار",
                content: confirmText,
                onOk: () => {
                  _form.onSubmit(
                    name,
                    value,
                    (err) =>
                      !err &&
                      this.setState({ editing: false }, () =>
                        _form.afterSubmit(name, value)
                      )
                  );
                  if (name === "provinceId") {
                    _form.onSubmit(
                      "cityId",
                      0,
                      (err) =>
                        !err &&
                        this.setState({ editing: false }, () =>
                          _form.afterSubmit(name, value)
                        )
                    );
                  }
                },
              });
            } else {
              _form.onSubmit(
                name,
                value,
                (err) =>
                  !err &&
                  this.setState({ editing: false }, () =>
                    _form.afterSubmit(name, value)
                  )
              );
              if (name === "provinceId") {
                _form.onSubmit(
                  "cityId",
                  0,
                  (err) =>
                    !err &&
                    this.setState({ editing: false }, () =>
                      _form.afterSubmit(name, value)
                    )
                );
              }
            }
            this.setState({ confirm: false });
          }
        }
      }
    }
  }

  /**
   *
   * @return {Boolean}
   * @private
   */
  get _valid() {
    const { value, values, editing } = this.state;
    const { required, validate } = this.props;

    if (editing) {
      if (!value || value.isEmpty()) {
        if (required) {
          return false;
        }
      } else {
        let _validate = validate(value, values);

        if (!(_validate === true || _validate === undefined)) {
          return false;
        }
      }
    }

    return true;
  }

  /**
   *
   * @return {String|undefined}
   * @private
   */
  get _error() {
    const { value, values, editing } = this.state;
    const { required, validate } = this.props;

    if (editing) {
      if (!value || value.isEmpty()) {
        if (required) {
          return app.translate("main.required");
        }
      } else {
        return validate(value, values);
      }
    }

    return undefined;
  }

  /**
   *
   * @return {XML}
   * @private
   */
  get _renderEdit() {
    const value = this.state.value;
    const { name, children, ...rest } = this.props;
    const Component = this.props.component;

    let omit = [
      "component",
      "validate",
      "forms",
      "parser",
      "editing",
      "masked",
      "confirmText",
      "componentName",
    ];

    if (this.props.acceptSize === undefined) {
      omit.push("closeAble");
    }

    return (
      <div ref={(input) => (this._node = input)}>
        <Component
          {...rest.$omit(omit)}
          name={name}
          value={value}
          defaultValue={value}
          onPressEnter={this._onSubmit}
          onChange={this._onChange}
          addonAfter={
            <span>
              <Icon
                name="close"
                size="tiny"
                tooltip={app.translate("main.Cancel")}
                onClick={this._onCancel}
                style={{ color: "#f44336" }}
              />
              &nbsp;
              <Icon
                name="content-save"
                size="tiny"
                tooltip={app.translate("main.Submit")}
                onClick={this._onSubmit}
                disabled={!this._valid}
                style={{ color: "#009688" }}
              />
            </span>
          }
        >
          {children}
        </Component>
      </div>
    );
  }

  /**
   *
   * @return {XML}
   * @private
   */
  get _renderView() {
    const { value, hovered } = this.state;
    const { parser, masked, disabled } = this.props;

    return (
      <div
        ref={(input) => (this._node = input)}
        onMouseOver={() => this.setState({ hovered: true })}
        onMouseLeave={() => this.setState({ hovered: false })}
        onClick={this._onEdit}
        className="ant-form-text"
        style={{
          lineHeight: "20px",
          cursor:
            this.context._form.disabled || disabled ? "default" : "pointer",
        }}
      >
        {this.context._form.masked || masked
          ? "******"
          : value &&
            typeof value === "string" &&
            moment(
              value,
              ["YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss"],
              true
            )?.isValid()
          ? moment(value).format("jYYYY-jMM-jDD")
          : !Number.isFinite(value) && app._.isEmpty(value)
          ? "-"
          : parser(value)}
        &nbsp;&nbsp;
        {hovered && !this.context._form.disabled && !disabled && (
          <Icon
            name="pencil"
            tooltip={app.translate("main.Edit")}
            onClick={this._onEdit}
            style={{ color: "#2196f3" }}
          />
        )}
      </div>
    );
  }

  /**
   *
   * @return {*}
   * @private
   */
  get _validateStatus() {
    const { editing, value } = this.state;

    if (editing) {
      if (!this._valid) {
        return "error";
      }

      if (!this.props.required && app._.isEmpty(value)) {
        return "warning";
      }

      return "success";
    }

    return undefined;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const { hint, label, className } = this.props;

    return (
      <Form.Item
        // {...this.props.$omit(["component", "validate", "required", "children"])}
        label={
          hint ? (
            <span>
              {label} {hint}
            </span>
          ) : (
            label
          )
        }
        className={`form-item-input ${className}`}
        required={this.state.editing && this.props.required}
        hasFeedback
        help={this._error}
        validateStatus={this._validateStatus}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: label ? 18 : 24 }}
        style={{ display: "flex" }}
      >
        {this.state.editing ? this._renderEdit : this._renderView}
      </Form.Item>
    );
  }
}
